module.exports = __webpack_public_path__ + "static/media/Kiran Melkote.aa57a757.png";